import React, {useEffect} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useStoreState } from "easy-peasy";
// import { HashLink } from 'react-router-hash-link';

function Home (props) {
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const contacts = useStoreState(state => state.contact_list.contacts);

  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement('script');
    script.src = "js/jquery.animateTyping.js";
    script.async = true;
    document.body.appendChild(script);
  return () => {
      document.body.removeChild(script);
    }
  }, []);

  return (
    <>
    {!is_logged_in &&
      <>
    <section className="pt-5 mt-3 bg-white">
      <div className="container py-5 h-100">
          <div className="row">
            <div className="col-md-9 mx-auto">
              <p className="h1 fs-4 text-center">A decade ago, we developed technology to help NCAA coaches reach elusive Gen Z student-athletes recruits with email — by utilizing links to bypass the inbox and deliver messages alternatively over realtime platforms.  Today, this technology holds the key to engaging Gen Z audiences with email now and into the future.</p>
            </div>
          </div>
          <div className="row d-flex align-content-center h-100">
              <div className="intro col-md-7 mx-auto position-relative">
                <img src="images/BTTF-tag.png" className="d-block mx-auto img-fluid my-4" width="500" alt="Back to the Future of Email" />
                <h1 class="text-center mb-5">PDF Documents</h1>
                <h4>WHITE PAPER:</h4>
                <ol className="list-group mb-5">
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/future.pdf" target="_blank">Back To The Future of Email</a></div>
                        </div>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/summary.pdf" target="_blank">Executive Summary</a></div>
                        </div>
                    </li>                                      
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/nutshell.pdf" target="_blank">HTMAIL in a Nutshell</a></div>
                        </div>
                    </li>
                </ol>
                <h4>EXCLUSIVES:</h4>
                  <ol className="list-group mb-5">
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/distinctions.pdf" target="_blank">HTMAIL Key Distinctions</a></div>
                            
                        </div>
                    </li>      
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/LINK-DRIVEN-MESSAGING.pdf" target="_blank">Advantages of Link-Driven Messaging</a></div>
                        </div>
                    </li>                                  
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/LINK-DRIVEN-EMAIL.pdf" target="_blank">Advantages of Link-Driven Email</a></div>
                        </div>
                    </li>
                </ol>
                <h4>FEATURES AND BENEFITS:</h4>
                  <ol className="list-group mb-5">
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/Features-and-Benefits-HTMAIL.pdf" target="_blank">HTMAIL Features and Benefits</a></div>
                            
                        </div>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/Features-and-Benefits-SENDERS.pdf" target="_blank">Sender Features and Benefits</a></div>
                        </div>
                    </li>                    
                    <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div class="ms-2 me-auto">
                            <div class="fw-bold"><a href="./docs/Features-and-Benefits-PROVIDERS.pdf" target="_blank">Provider Features and Benefits</a></div>
                            
                        </div>
                    </li>
                </ol>
              </div>
          </div>
      </div>
    </section>

     </>
    }
    {is_logged_in &&
      <>
      <div id="content" className="container py-5">
      <div className="row pt-5 mt-4">
        <div className="col-md-6">
          <h2 className="h4"><i className="fas fa-tachometer-alt"></i> Dashboard</h2>
        </div>
        <div className="col-md-6 text-md-end">
        {contacts.length > 0 ? (
        <Link to="/contacts" className="btn btn-primary" role="button">Send your first HTMAIL</Link>
        ) : (
        <Link to="/messages" className="btn btn-primary" role="button">Send your first HTMAIL</Link>
        )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-dark h4 text-white">
              First Time Setup
            </div>
            <div className="card-body">

              <div className="accordion accordion-flush" id="accordionFlush">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                      1. Set Up a Domain
                    </button>
                  </h2>
                  <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlush">
                    <div className="accordion-body">Before creating any HTMAIL messages, you'll want to add one of your domains so your recipients know your messages are coming from you.  To do this, click "Account" at the top and select "Domains".  After you add your domain name, you'll need to update your DNS records and add a CNAME record that points your domain to "htmail.link".  Then simply press the "Check" button next to your name to validate and start using it!
                  </div>
                </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                      2. Setup Twilio
                    </button>
                  </h2>
                  <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlush">
                    <div className="accordion-body">
                        <div className="row">
                          <div className="col-12">Next, if you would like to easily send your HTMAIL messages via SMS, you need to link your Twilio account. Click the "Account" link at the top, and select "Integrations" for instructions on how to do this.
                          </div>
                          <div className="col-12">
                              <Link to="/account/integrations" className="btn btn-primary mt-3">Setup Twilio</Link>
                          </div>
                      </div>
                  </div>
                </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                      3. Use API
                    </button>
                  </h2>
                  <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlush">
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-12">For programmatic access to HTMAIL, we have an API available for all functionality. See the "API Docs" link under "Accounts" for the API documentation.
                        </div>
                        <div className="col-12">
                          <Link to="/account/api_keys" className="btn btn-primary mt-3">API Keys</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      </div>
      </>
    }
  </>);
}

export default withRouter(Home);
